export default {
  // HTTP
  HTTP_METHOD: "http.method",
  HTTP_URL: "http.url",
  NET_PEER_NAME: "net.peer.name",
  HTTP_STATUS_CODE: "http.status_code",
  HTTP_USER_AGENT: "http.user_agent",
  HTTP_RESPONSE_CONTENT_LENGTH: "http.response_content_length",
  HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED: "http.response_content_length_uncompressed",

  // Page
  PAGE_URL: "page.url",
  PAGE_HASH: "page.hash",
  PAGE_ROUTE: "page.route",
  PAGE_HOSTNAME: "page.hostname",
  PAGE_SEARCH: "page.search",

  // URL
  URL_PATH: "url.path",

  // Custom
  INITIATOR_TYPE: "initiator_type",
  DELIVERY_TYPE: "delivery_type",
  SIZE: "size",
  NETWORK_TIMINGS: "network.timings",
  NETWORK_TRANSFER_SIZE: "network.transfer_size",

  // View
  VIEW_ID: "view.id",

  // Session (OTEL RUM aligned)
  SESSION_ID: "session.id",
  SESSION_PREVIOUS_ID: "session.previous_id",

  // User
  USER_ID: "user.id",
  USER_NAME: "user.name",
  USER_FULL_NAME: "user.full_name",
  USER_EMAIL: "user.email",
  USER_ROLES: "user.roles",

  // Exception
  EXCEPTION_TYPE: "exception.type",
  EXCEPTION_MESSAGE: "exception.message",
  EXCEPTION_STACKTRACE: "exception.stacktrace",

  // User Interactions
  INTERACTION_TYPE: "interaction.type",
  INTERACTION_TIMESTAMP: "interaction.timestamp",
  INTERACTION_TARGET_TAG_NAME: "interaction.target.tag_name",
  INTERACTION_TARGET_ID: "interaction.target.id",
  INTERACTION_TARGET_CLASS_NAME: "interaction.target.class_name",
  INTERACTION_TARGET_SELECTOR: "interaction.target.selector",
  INTERACTION_TARGET_TEXT: "interaction.target.text",
  INTERACTION_TARGET_ROLE: "interaction.target.role",
  INTERACTION_TARGET_NAME: "interaction.target.name",
  INTERACTION_TARGET_TYPE: "interaction.target.type",
  INTERACTION_TARGET_PLACEHOLDER: "interaction.target.placeholder",
  INTERACTION_TARGET_ARIA_LABEL: "interaction.target.aria_label",
  INTERACTION_TARGET_ARIA_LABELLEDBY: "interaction.target.aria_labelledby",
  INTERACTION_TARGET_ARIA_DESCRIBEDBY: "interaction.target.aria_describedby",
  INTERACTION_TARGET_TITLE: "interaction.target.title",
  INTERACTION_TARGET_HTML_FOR: "interaction.target.html_for",
  INTERACTION_TARGET_LABEL_TEXT: "interaction.target.label_text",
  INTERACTION_POSITION_X: "interaction.position.x",
  INTERACTION_POSITION_Y: "interaction.position.y",
  INTERACTION_DURATION: "interaction.duration",

  // Scroll interactions
  SCROLL_DEPTH_PERCENT: "scroll.depth_percent",
  SCROLL_DIRECTION: "scroll.direction",

  // Keyboard interactions
  KEYBOARD_KEY: "keyboard.key",
  KEYBOARD_CODE: "keyboard.code",

  // Form interactions
  FORM_FIELD_NAME: "form.field.name",
  FORM_FIELD_TYPE: "form.field.type",
  FORM_FIELD_VALUE_LENGTH: "form.field.value_length",

  // Touch interactions
  TOUCH_DURATION: "touch.duration",
  TOUCH_GESTURE_TYPE: "touch.gesture_type",

  // Error tracking
  ERROR_STACK_FRAMES: "error.stack.frames",
  ERROR_FILENAME: "error.filename",
  ERROR_LINENO: "error.lineno",
  ERROR_COLNO: "error.colno",
  ERROR_SOURCE: "error.source",
  ERROR_HANDLED: "error.handled",
  ERROR_RATE_LIMITED_COUNT: "error.rate_limited.count",
};
